import { Fb, Ig, Mail, Svg } from "./icons";

export const NAV = [
  ["/", "Home"],
  ["/about", "About"],
  ["/services", "Services"],
  ["/referrals", "Referrals"],
  ["/book", "Book"],
  ["/consent", "Consent"],
  ["/contact", "Contact"],
] as const;

export const TITLES: Record<string, string> = {
  "/": "WarmNest Counselling — A nurturing space to heal and grow",
  "/about": "About — WarmNest Counselling",
  "/services": "Services & Rates — WarmNest Counselling",
  "/referrals": "Referrals — WarmNest Counselling",
  "/referrals/incoming": "Incoming Referral Form — WarmNest Counselling",
  "/referrals/outgoing": "Outgoing Referral Form — WarmNest Counselling",
  "/book": "Book a Session — WarmNest Counselling",
  "/consent": "Consent & Boundaries — WarmNest Counselling",
  "/contact": "Contact — WarmNest Counselling",
};

export function normalize(path: string) {
  const clean = path.split("?")[0];
  return clean.length > 1 && clean.endsWith("/") ? clean.slice(0, -1) : clean;
}

function Logo() {
  return <img className="logo" src="/logo.png" alt="WarmNest Counselling — Heal · Grow · Thrive" />;
}

export function Leaves() {
  return (
    <div className="leaves" aria-hidden="true">
      <svg className="leaf a" viewBox="0 0 200 200" width="280" height="280">
        <path d="M20 180 Q 40 100 100 60 Q 60 120 40 180" fill="oklch(0.82 0.06 145)" opacity="0.5" />
        <path d="M60 190 Q 80 110 140 70 Q 100 130 80 190" fill="oklch(0.78 0.07 130)" opacity="0.4" />
      </svg>
      <svg className="leaf b" viewBox="0 0 200 200" width="380" height="380">
        <path d="M180 20 Q 100 40 60 100 Q 140 60 180 40" fill="oklch(0.82 0.06 145)" opacity="0.35" />
        <path d="M170 60 Q 90 80 50 140 Q 130 100 170 80" fill="oklch(0.78 0.07 130)" opacity="0.3" />
      </svg>
      <svg className="leaf c" viewBox="0 0 200 200" width="320" height="320">
        <path d="M100 20 C 130 60 130 120 100 180 C 70 120 70 60 100 20 Z" fill="oklch(0.85 0.05 25)" opacity="0.3" />
      </svg>
    </div>
  );
}

export function Header({ path, open, toggle }: { path: string; open: boolean; toggle: () => void }) {
  return (
    <header className="header">
      <div className="header-inner">
        <a className="brand" href="/">
          <Logo />
        </a>
        <button className="menu-btn" aria-label="Toggle menu" aria-expanded={open} onClick={toggle}>
          <Svg><path d="M4 7h16M4 12h16M4 17h16" /></Svg>
        </button>
        <nav className={open ? "nav open" : "nav"}>
          {NAV.map(([href, label]) => (
            <a key={href} href={href} className={path === href || (href !== "/" && path.startsWith(href)) ? "active" : undefined} aria-current={path === href ? "page" : undefined}>
              {label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
}

export function Footer() {
  return (
    <footer>
      <div className="foot">
        <div>
          <a className="brand" href="/">
            <Logo />
          </a>
          <p className="muted">A safe, inclusive, and confidential space for all.</p>
        </div>
        <div>
          <h4>Quick Links</h4>
          <ul>
            <li><a href="/">Home</a></li>
            <li><a href="/services">Services</a></li>
            <li><a href="/referrals">Referrals</a></li>
            <li><a href="/book">Book Now</a></li>
            <li><a href="/consent">Consent</a></li>
            <li><a href="/contact">Contact</a></li>
          </ul>
        </div>
        <div>
          <h4>Connect</h4>
          <div className="social">
            <a href="#instagram" aria-label="Instagram"><Ig /></a>
            <a href="#facebook" aria-label="Facebook"><Fb /></a>
            <a href="mailto:warmnestcounselling@gmail.com" aria-label="Email"><Mail /></a>
          </div>
          <span className="reg"><span className="dot" />ASCHP Registered</span>
        </div>
      </div>
      <div className="copy">© {new Date().getFullYear()} WarmNest Counselling. All rights reserved.</div>
    </footer>
  );
}

export function Credentials() {
  return (
    <div className="card" style={{ borderRadius: "1.5rem" }}>
      <p className="display" style={{ fontSize: "1.25rem", margin: "0 0 0.25rem" }}>Kgaugelo Paggy Tefo</p>
      <p className="soft" style={{ margin: "0.15rem 0" }}>Specialised Wellness Counsellor</p>
      <p className="soft" style={{ margin: "0.15rem 0" }}>ASCHP Membership No. 8806 · Registration No. SWC24/7080</p>
      <p className="soft" style={{ margin: "0.15rem 0" }}>Valid 2025-05-06 to 2027-05-06 · SAQA Professional Body ID 984</p>
      <p className="soft" style={{ margin: "0.15rem 0" }}>Sessions 100% online — nationwide South Africa</p>
      <p style={{ margin: "0.75rem 0 0" }}>
        <a className="link" href="mailto:warmnestcounselling@gmail.com">warmnestcounselling@gmail.com</a>
        {" · "}
        <a className="link" href="tel:+27814727220">081 472 7220</a>
      </p>
    </div>
  );
}
